import { getAuth } from "firebase/auth";
import React, { useState, useEffect } from "react";

export default function FirebaseAuthGuard({ children }) {
  const [hasSignedIn, setHasSignedIn] = useState(false);
  useEffect(() => {
    try {
      const auth = getAuth();
      if (auth) {
        setHasSignedIn(true);
      } else {
        const firebaseToken = firebaseKit.auth.getToken();
        firebaseKit.auth
          .signInWithCustomToken(firebaseToken)
          .then(() => {
            setHasSignedIn(true);
          })
          .catch((e) => {
            console.error(e);
          });
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  // return <>{hasSignedIn && children}</>;
  return <>{children}</>;
}
